import { useQuery } from 'react-query';
import { debounce, noop } from 'lodash';
import { fetchInitialData } from '@fiverr-private/send_message';
import { logError, wrapTrackRequestMetrics } from '../services/utils';

const QUERY_BASE_KEY = 'contact-data';

/** @type {any} */
const akaServiceName = 'send_message_package';
const fetchInitialContactData = wrapTrackRequestMetrics(fetchInitialData, akaServiceName, {
    requestName: 'fetchInitialData',
    pathfinderUIRequest: true,
});

const logQueryError = debounce((e) => logError('Failed to fetch contact data', { error: e }));

// TODO: fetchInitialContactData fails if user has pending state
// need to discuss with owner of send_message package
export const useContactDataQuery = ({ username, isLoggedIn, enabled, onSuccess = noop, onError = noop }) => {
    const {
        isLoading,
        data: modalInitialData,
        refetch: refetchInitialData,
    } = useQuery(
        [QUERY_BASE_KEY, username, isLoggedIn],
        () => (isLoggedIn ? fetchInitialContactData(username) : null),
        {
            enabled,
            onSuccess,
            onError: (e) => {
                logQueryError(e);
                onError(e);
            },
        }
    );

    return {
        isLoading,
        modalInitialData,
        refetchInitialData,
    };
};
